module.exports = __webpack_public_path__ + "img/group-nodes.dfbc751f.svg";